import React from 'react';
import { Result, Button, Typography } from 'antd';

/**
 * Catches a rendering error in the current screen so the rest of the app
 * stays usable, and shows the message so it can be reported. The boundary
 * resets when the route changes (see MainLayout, keyed by pathname).
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('Screen error', error, info && info.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    const message = this.state.error && this.state.error.message ? this.state.error.message : String(this.state.error);
    return (
      <Result
        status="error"
        title="Something went wrong on this screen"
        subTitle={
          <span>
            Reload the page to try again. If it keeps happening, send this to support:{' '}
            <Typography.Text code>{window.location.pathname}</Typography.Text> <Typography.Text code>{message}</Typography.Text>
          </span>
        }
        extra={[
          <Button key="reload" type="primary" onClick={() => window.location.reload()}>
            Reload
          </Button>,
          <Button key="home" onClick={() => window.location.assign('/')}>
            Go to Workspace
          </Button>,
        ]}
      />
    );
  }
}
